export const PetRoute = {
  Login: '/login',
  Home: '/home',
  Listing: `/listing`,
  Listings: `/listings`,
  ListingsPendingBreeder: `/listings/pendingBreeder`,
  ListingsAvailable: '/listings/available',
  ListingsUnavailable: '/listings/unavailable',
} as const;

export const ParentType = {
  Dam: 'dam',
  Sire: 'sire',
} as const;

export const WorkflowId = {
  Listing: 1,
  Parent: 2,
} as const;

export const ListingWorkflowStatusId = {
  Submitted: 1,
  ApprovalInProgress: 2,
  Approved: 3,
  PendingWorkAcceptance: 4,
  Postponed: 5,
  Forwarded: 6,
  ForwardReviewInProgress: 14,
} as const;

export const ParentsWorkflowStatusId = {
  Submitted: 7,
  ApprovalInProgress: 8,
  Approved: 9,
  PendingWorkAcceptance: 10,
  Postponed: 11,
  Forwarded: 12,
  ForwardReviewInProgress: 13,
} as const;

export const WorkflowStatusLabel = {
  Submitted: 'Submitted',
  ApprovalInProgress: 'Approval in progress',
  Approved: 'Approved',
  PendingWorkAcceptance: 'Pending Work Acceptance',
  Postponed: 'Postponed',
  Forwarded: 'Forwarded',
  ForwardReviewInProgress: 'Forward Review in progress',
} as const;

export const PetWorkflowStatusId = {
  Approved: ListingWorkflowStatusId.Approved,
  PendingReview: ListingWorkflowStatusId.PendingWorkAcceptance,
  Forwarded: ListingWorkflowStatusId.Forwarded,
  InProgress: ListingWorkflowStatusId.ApprovalInProgress,
  PendingBreeder: ListingWorkflowStatusId.Postponed,
  NotDefined: 0,
} as const;

export const PetWorkflowStatusLabel = {
  Approved: 'Approved',
  PendingReview: 'Pending Review',
  Forwarded: 'Forwarded',
  InProgress: 'In Progress',
  PendingBreeder: 'Pending Breeder',
  NotDefined: 'Not Defined',
} as const;

export const PetWorkflowStatusAcronym = {
  Approved: 'AP',
  PendingReview: 'PR',
  Forwarded: 'FW',
  InProgress: 'IP',
  PendingBreeder: 'PB',
  NotDefined: 'ND',
} as const;

export const PetWorkflowStatusSlug = {
  Approved: 'approved',
  PendingReview: 'pending-review',
  Forwarded: 'forwarded',
  InProgress: 'in-progress',
  PendingBreeder: 'pending-breeder',
  NotDefined: 'not-defined',
} as const;

export const ListingStatusId = {
  Created: 1,
  Live: 2,
  Sold: 3,
  Hidden: 4,
  Removed: 5,
} as const;

export const ListingStatusLabel = {
  Created: 'Created',
  Live: 'Live',
  Sold: 'Sold',
  Hidden: 'Hidden',
  Removed: 'Removed',
} as const;

export const InventoryStatusId = {
  Available: 1,
  PendingSale: 2,
  SoldByBreeder: 3,
  NotAvailable: 4,
  Reserved: 5,
  Replacement: 6,
  Sold: 7,
} as const;

export const InventoryStatusLabel = {
  Available: 'Available',
  PendingSale: 'Pending Sale',
  SoldByBreeder: 'Sold By Breeder',
  NotAvailable: 'Not Available',
  Reserved: 'Reserved',
  Replacement: 'Replacement',
  Sold: 'Sold',
} as const;

export const BreederContractTermTypeId = {
  Commitment: 1,
  Feature: 2,
} as const;

export const MarketingStatusId = {
  General: 1,
  Featured: 2,
  SpotOn: 3,
  Committed: 4,
  CommittedShortTerm: 5,
} as const;

export const ListingMarketingStatus: { [key: string]: string } = {
  '1': 'General',
  '2': 'Featured',
  '3': 'Spot-On',
  '4': 'Committed',
  '5': 'Committed Short Term',
};
